var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ElementRef, Output, EventEmitter } from '@angular/core';
import { AbstractComponent } from 'gp-admin-abstract';
var PopupComponent = /** @class */ (function (_super) {
    __extends(PopupComponent, _super);
    function PopupComponent(el) {
        var _this = _super.call(this, el) || this;
        _this.el = el;
        _this.onShow = new EventEmitter();
        _this.onHide = new EventEmitter();
        /**
         * Индикатор показа всплывающего окна
         *
         * @type {boolean}
         */
        _this.isShow = false;
        return _this;
    }
    /**
     * Для закрытия
     */
    PopupComponent.prototype.hide = function () {
        this.isShow = false;
        this.onHide.emit();
    };
    /**
     * Для показа
     */
    PopupComponent.prototype.show = function () {
        this.isShow = true;
        this.onShow.emit();
    };
    /**
     * Переключатель
     */
    PopupComponent.prototype.toogle = function () {
        this.isShow ? this.hide() : this.show();
    };
    PopupComponent.decorators = [
        { type: Component, args: [{
                    selector: 'gp-popup',
                    template: "\n<div class=\"gp-popup pa top right bottom left\" [hidden]=\"!isShow\">\n    <form class=\"modal-form bg border--radius-all\">\n        <ng-content></ng-content>\n    </form>\n</div>\n",
                    styles: [
                        "@charset \"UTF-8\";\n/**\n * \u041F\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0435\n */\n:root {\n  --color-white: white;\n  --color-success: #00afec;\n  --color-warning: #ffb827;\n  --color-error: #f35252;\n  --color-disabled: #dbdbdb;\n  --color-black: black;\n  --color-span: #b5b5b5;\n  --color-span-second: #212121;\n  --color-bg: #f8f8f8;\n  --color-bg-second: #f8f8f8;\n  --color-bg-success: rgba(0, 175, 236, 0.1);\n  --color-bg-warning: var(--color-warning);\n  --color-bg-error: var(--color-error);\n  --color-placeholder: #b5b5b5;\n  --color-border: #dbdbdb;\n  --color-radio-border: #d3d3d3;\n  --font-roboto: 'Roboto', sans-serif;\n  --font-helvetica: 'Helvetica', sans-serif; }\n\n/**\n *\n */\n/**\n * \u0421\u0442\u0438\u043B\u0438 \u0434\u043B\u044F \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0430 \"gp-popup\"\n */\n.gp-popup {\n  z-index: 100;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  height: 100%;\n  min-height: 100vh;\n  padding-bottom: 2.5rem;\n  background-color: rgba(33, 33, 33, 0.8); }\n  .gp-popup__text {\n    color: #212121;\n    font-weight: 400 1.4rem/2rem \"Roboto\", sans-serif;\n    letter-spacing: 0.03rem; }\n\n.modal-form {\n  font-family: \"Roboto\", sans-serif;\n  position: absolute;\n  top: 5rem;\n  left: 50%;\n  width: 50rem;\n  margin-bottom: 5rem;\n  padding: 2rem;\n  -moz-transform: translateX(-50%);\n  -o-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  border: 0.1rem solid #dbdbdb; }\n"
                    ]
                },] },
    ];
    /** @nocollapse */
    PopupComponent.ctorParameters = function () { return [
        { type: ElementRef, },
    ]; };
    PopupComponent.propDecorators = {
        'onShow': [{ type: Output },],
        'onHide': [{ type: Output },],
    };
    return PopupComponent;
}(AbstractComponent));
export { PopupComponent };
//# sourceMappingURL=popup.component.js.map